export const questionnaire = {
  resendGroup: 'Reenviar grupo',
  selectGroup: 'Seleccionar grupos',
  'groupSelected_one': '{{group}} Grupo seleccionado',
  'groupSelected_other': '{{group}} Grupos seleccionados',
  groups: 'Grupos',
  selectedGroups: 'Grupos seleccionados',
  group: 'Grupo',
  skipTo: 'Salta a la pregunta: {{question}}',
  "anotherQuestion": "Crear desde otro cuestionario",
  createQuestionnaire: "Nuevo cuestionario",
  editQuestionnaire: "Editar cuestionario",
  reportWithSignature: "Reporte con firma",
  signature: "Firma",
  "signaturesWithoutDescription": "Algunas firmas no tienen descripción. Por favor completa todas antes de guardar.",
  "signatureDescriptionRequired": "La descripción de la firma es obligatoria.",
  "saveQuestionnairesChanges": "¿Quieres guardar los cambios realizados antes de continuar?",
  "saveQuestionnairesChangesDescription": "Puedes continuar sin perder los cambios realizados.",
  "title": "Cuestionarios",
  "configNotFound": "Se han encontrado campos sin configuración",
  "totalPoints": "Los puntos cargados deben ser iguales a los totales",
  "reportFolio": "Folios", 
  "actionPlan": "Planes de acción",
  "settingFolio": "Configuración de folio",
  "settingActionPlan": "Configuración de plan de acción",
  "maxAmountFolios": "Cantidad máxima de folios",
  "maxAmountRejects": "Cantidad máxima de rechazos",
  "countPoint": "Contar los puntos",
  "noMock": "Ninguna",
  "NoReportsAvailable":"No hay reportes disponibles",
  recurrenceTitle: 'Configuración de alerta de reincidencia',
  recurrenceSub: 'Al activar una alerta de reincidencia, el usuario no podrá crear otro plan de acción si existe otro relacionado con el mismo item/pregunta',
  "detailOfQuestionnaireExecution": "Detalle de ejecución de cuestionario",
  "startDate": "Fecha de inicio",
  "questionnaireStructure": "Estructura del cuestionario",
  "csvExecution": "Ejecución en Excel",
  "pdfExecution": "Ejecución en PDF",
  "csvAnswer": "Respuestas en Excel",
  "filterTitle": "Filtrar por",
  "apply":"APLICAR",
  "cards":{
    "generated": "Generados",
    "resolved": 'Resueltos',
    "total": "Total",
    "sectionss":"Secciones",
    "questions":"Preguntas",
    "totalPoints":"Puntos totales",
    "scheduled":"Programados",
    "completed":"Finalizados",
    "notCompleted":"No finalizados",
    "averageMark":"Calificación promedio",
    "approved": "Aprobados",
    "rejected": "Rechazados"
  },
  mustBeSelectSomeEvidence: "Debes configurar al menos una evidencia.",
  maxReincidence: 'Número para detonar la reincidencia.',
  blocks: 'Cantidad de veces que llegará la reincidencia a un usuario.',
  imageWasLoaded: 'La imagen se cargó exitosamente',
  wrongLoadImage: 'Ocurrió un error al cargar la imagen',
  newQuestion: 'Nueva Pregunta',
  answers: 'Respuestas',
  textRequired: '(Requiere campo de texto)',
  answerType: 'Tipo de pregunta',
  noTemplate: 'La pregunta no tiene opciones',
  general: 'General',
  item: 'Por ítem',
  noSection: 'No hay secciones configuradas',
  configOf: 'Configuración de {type}',
  typeConfig: {
    questionnaire: 'Cuestionario',
    section: 'Sección',
    question: 'Pregunta',
    item: 'ítem',
  },
  "manageUser": {
    "submit": {
      "snackbar": {
        "update": {
          "success": "Los permisos se actualizaron exitosamente",
          "error": "Ocurrió un error al actualizar los permisos"
        }
      },
      "update": "Actualizar permisos",
      "create": "Guardar cuestionario",
      "modal": {
        "description": "¿Estás seguro que desea actualizar los permisos del cuestionario?",
        "title": "Atento",
        "settingPermissions": "Debe completar los campos requeridos del cuestionario para configurar los permisos",
        "noChanges": "No se han realizado cambios en los permisos"
      }
    },
    "access": "Aplica",
    "report": "Informe",
    "emailNotification": "Email",
    "result": "Resultados",
    "title": "Listado de accesos a este cuestionario",
    "execution" : "Ejecución",
    "disable" : "Deshabilitar"
  },
  "modal": {
    "permisssion": {
      "title": "Búsqueda de usuarios",
      "subtitle": "Utilice los filtros para encontrar a los usuarios que desea agregar"
    },
    "reportFolio": {
      "title": "Confirmación",
      "description": "¿Deseas que el plan de acción asociado a esta pregunta pueda generar folios?",
      "cancel": {
        "title": "¿Esta seguro que desea eliminar el folio?",
        "description": "Se perderán las configuraciones realizadas"
      }
    },
    "activeByQuestion": "Si habilita la opción de evidencias por pregunta, toda configuración que pueda haber realizado en las evidencias por respuesta se perderá",
    "activeByOptions": "Si habilita la opción de evidencias por respuestas, toda configuración que pueda haber realizado en las evidencias por pregunta se perderá",
    "permission": {
      "create": "Creación de cuestionario",
      "update": "Actualización de cuestionario",
      "description": "¿Está seguro que desea guardar el cuestionario con la configuración de permisos actual?",
      "errors": {
        "title": "Hubo un error en la asignación de los permisos",
        "00": "Ocurrió un error en la creación de los permisos",
        "01": "Los permisos no fueron creados, debido a que algunos usuarios no cuentan con los permisos necesarios"
      }
    },
    "title": "Nuevo cuestionario",
    "anotherQuestion": "Crear desde otro cuestionario",
    "newQuestionnarie": "Crear un nuevo cuestionario",
    "table": {
      "filterTitle": "Seleccione el cuestionario del que se creará una copia que luego podrás editar",
      "search": "Buscar cuestionario"
    },
    "score": {
      "title": "Se superó la cantidad de puntos máximos por respuesta correcta",
      "notMinus": "Los puntos totales no deben ser menores a la suma de las opciones correctas",
      "description": "Las respuestas correctas no deben superar los"
    },
    "footer": {
      "title": "Configuración de plan de acción"
    },
    "success": {
      "create": {
        "title": "El cuestionario ha sido creado",
        "description": "A continuación puedes editar el contenido del cuestionario y sus políticas de planes de acción"
      },
      "copy": {
        "title": "La copia de este cuestionario ha sido creada",
        "description": "Puede editar este cuestionario, el original no se verá afectado"
      }
    },
    "delete": {
      "title": "¿Está seguro que desea eliminar este cuestionario?",
      "description": "Al eliminar un cuestionario, se borrará de tu lista y debes realizar nuevamente su configuración",
      "success": {
        "title": "El cuestionario se eliminó exitosamente",
        "description": ""
      },
      "error": {
        "title": "Hay un error y el cuestionario no puede ser eliminado",
        "description": "El cuestionario ya ha sido asignado a una visita, no se puede eliminar"
      }
    },
    "section": {
      "title": "¿Está seguro que desea eliminar esta sección?",
      "description": "Al eliminar la sección, se perderán las configuraciones realizadas"
    },
    "question": {
      "title": "¿Está seguro que desea eliminar esta pregunta?",
      "description": "Al eliminar la pregunta, se perderán las configuraciones realizadas"
    },
    "answer": {
      "title": "¿Está seguro que desea eliminar esta respuesta?",
      "description": "Al eliminar la respuesta, se perderán las configuraciones realizadas"
    },
    "submit": {
      "success": {
        "title": "El cuestionario ha sido guardado exitosamente",
        "description": "Ahora puede utilizar este cuestionario para la programación que requiera"
      },
      "error": {
        "title": "Hay un error y el cuestionario no puede ser guardado",
        "description": ""
      }
    }
  },
  "sections": {
    "questDescription": "Descripción del cuestionario",
    "questInstruction": "Instrucciones del cuestionario",
    "evidenceTypes": "Evidencias Requeridas",
    "evidenceTypes2": "Evidencias requeridas",
    "evidenceTypes3": "Evidencias",
    "folioManagement": "Gestión de folio"
  },
  "snackbar": {
    "copy": {
      "error": "Ocurrió un error al crear la copia del cuestionario",
      "success": "La copia se creó exitosamente"
    },
    "create": {
      "error": "Ocurrió un error al crear el cuestionario",
      "success": "El cuestionario se creó exitosamente"
    },
    "update": {
      "error": "Ocurrió un error al actualizar el cuestionario",
      "success": "El cuestionario se actualizó exitosamente"
    }
  },
  "errors": {
    "ERR_UPDATING": "El cuestionario ya ha sido asignado a una visita, no puede ser actualizado"
  },
  "fields": {
    "ansers": "Respuesta",
    "pts": "Valor pts",
    "action": "Acción",
    "textHelp": "Texto de ayuda",
    "activeActionPlan": "Activa opción de plan de acción",
    "anserText": "Texto de la respuesta",
    "questText": "Texto de la pregunta",
    "canAddComments": "Puede agregar comentarios",
    "optionQuest": "Opciones de preguntas",
    "mock": "Plantilla de respuesta",
    "sectionName": "Nombre de la sección",
    "sectionDescription": "Descripción de la sección",
    "correctOption": "Opción correcta",
    "questionnarieName": "Nombre del cuestionario",
    "description": "Descripción",
    "instructions": "Instrucciones",
    "addAnswer": "Agregar respuesta",
    "addQuestion": "Agregar Pregunta",
    "sendQuestionnarie": "Enviar cuestionario",
    "noDataFound": "No se encontraron datos",
    "recurrenceAlerts": "alertas de reincidencias",
    "listOfVersions": "Listado de versiones",
    "noOptions": "Sin opciones",
    "addSignature":"Agregar firma",
    "signatureDescription":"Descripción de la firma",
    "addComment": "Agregar comentario",
    "requeiredSignature":"Firma obligatoria",
    "required": "Obligatorio"
  },
  "order": {
    "configOrder": "Configurar ordenamiento del cuestionario",
    "areaAndDepartment": "El área y departamento serán campos obligatorios en la creación del folio.",
    "addOnceEvidence": "Debes agregar al menos una pregunta al plan de acción o al menos solicitar una evidencia.",
    "addOnceConfig": "Debes agregar al menos una configuración al folio o al menos solicitar una evidencia.",
    "warningOrder": "El cambio en el orden de las preguntas dentro de una sección afectará la configuración hecha en las acciones del salto de preguntas.",
    "save": "Aplicar ordenamiento"
  },
  "permissions" : {
    "assigningQuestionnairePermissions" : "Asignación de permisos del cuestionario",
    "searchForUsers" : "Buscar usuarios",
    "selectUsersToAdd" : "Seleccione los usuarios que desea agregar",
    "addUsers" : "Agregar usuarios",
    "assigningPermissions" : "Asignación de permisos",
    "users" : "Usuarios",
    "questionnaireAccess" : "Accesos de cuestionario",
    "questionnaire" : "Cuestionario",
    "folio" : "Folios"
  }
}